import { connect } from 'react-redux'
import { setActiveModal } from 'registry/actions'
import {
  getDevicePlatform,
  getRegistryUIState,
  getRegistrySetupGoalsToDisplay,
} from 'registry/reducers'
import RegistrySetup from './registry-setup'

const mapStateToProps = (state) => ({
  goals: getRegistrySetupGoalsToDisplay(state),
  hasSeenHelloBabyBoxQualified:
    !!getRegistryUIState(state).hasSeenHelloBabyBoxQualified,
  devicePlatform: getDevicePlatform(state),
  isWishlist: !!state.registry?.type,
  registryId: state.registry?.id,
})

export default connect(mapStateToProps, { setActiveModal })(RegistrySetup)
